import { useExperiments } from '@wix/fe-essentials/react';
import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { inaccessibleComponentsSessionPagesAtom, inaccessibleLayoutSessionPagesAtom } from '../../../../../atoms/session-atoms';
import { usePanelStateAtom } from '../../../../../hooks/rules-state';
import { useGetRuleIds } from '../../../../../utils/get-rule-ids';
export const useGetPageRuleIds = (pageId, ruleIds) => {
  const {
    experiments
  } = useExperiments();
  const {
    getGroupData,
    getPagesData
  } = usePanelStateAtom();
  const pagesData = getPagesData();
  const pageData = pagesData.get(pageId);
  const inaccessibleComponentsPages = useAtomValue(inaccessibleComponentsSessionPagesAtom);
  const inaccessibleLayoutPages = useAtomValue(inaccessibleLayoutSessionPagesAtom);
  const isInaccessibleComponentsRuleEnabled = experiments.enabled('specs.responsive-editor.EnableInaccessibleComponentsRule');
  const getRuleIds = useGetRuleIds();
  const ruleIdsToUse = useMemo(() => {
    return ((ruleIds == null ? void 0 : ruleIds.length) ?? 0) > 0 ? ruleIds : getRuleIds({
      getGroupData,
      inaccessibleComponentsPages,
      inaccessibleLayoutPages,
      isInaccessibleComponentsRuleEnabled,
      pageData,
      pageId
    });
  }, [ruleIds, getRuleIds, getGroupData, inaccessibleComponentsPages, inaccessibleLayoutPages, isInaccessibleComponentsRuleEnabled, pageData, pageId]);
  return ruleIdsToUse;
};
//# sourceMappingURL=use-get-page-rule-ids.js.map